<script setup>
import ga4 from '#common/utils/ga4'

const memberships = useMemberships()
const visibleMemberships = computed(() => memberships.visibleMemberships)
await useAsyncData(() => memberships.loadMemberships().then(() => true))

onMounted(async () => {
  ga4.track('view_clubs_gifting')
})
</script>

<template>
  <div class="wineclub wineclub-splash gifting">
    <section class="hero shaded">
      <div class="hero-image">
        <div class="hero-block">
          <h1>
            A Wine Club for<br />
            Every Wine Lover
          </h1>
          <ol>
            <li>Choose the club</li>
            <li>Select the number of shipments</li>
          </ol>
        </div>
      </div>
      <div class="row">
        <ul class="generic-grid" style="margin-bottom: 0">
          <WineClubCard
            v-for="membershipType in visibleMemberships"
            :key="membershipType.slug"
            :membership-type="membershipType"
            :link-url="`/wine-club/gifting/${membershipType.slug}/`"
            cta-text="Gift This Club"
            :use-price-range="false"
          />
        </ul>
      </div>
      <div class="row">
        <div class="columns">
          <div class="gift-contact">
            <p class="head">Looking to gift multiple clubs?</p>
            <p>
              Email Us:
              <strong>
                <CustomerServiceEmailLink />
              </strong>
            </p>
            <p>
              Call Us:
              <CustomerServicePhoneLink
                :use-bold="true"
                :include-from-word="false"
                :with-hours-short="true"
              />
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
